const LOGO_URL = "https://customer-assets.emergentagent.com/job_72787016-fe41-45ba-b43d-2a00bb731c23/artifacts/zzginc20_SaiResponse.png";

/**
 * SaiResponse logo — geometric S/I monogram referencing twin sai daggers.
 * Sized via the `size` prop. Tagline rendered beneath when `showTagline`.
 */
export const Logo = ({ size = 36, showTagline = true, compact = false, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="sai-logo">
      <div
        className="relative shrink-0 grid place-items-center rounded-sm overflow-hidden"
        style={{ width: size, height: size, background: "rgba(0,128,128,0.08)", border: "1px solid rgba(0,128,128,0.35)" }}
      >
        <img
          src={LOGO_URL}
          alt="SaiResponse"
          className="object-contain"
          style={{ width: size * 0.92, height: size * 0.92, filter: "drop-shadow(0 0 6px rgba(0,128,128,0.45))" }}
        />
      </div>
      {!compact && (
        <div className="flex flex-col leading-none">
          <span className="font-display text-white text-[17px] tracking-tight">
            <span className="font-black">Sai</span>
            <span className="font-light text-white/90">Response</span>
          </span>
          {showTagline && (
            <span className="mt-1 text-[9.5px] tracking-[0.18em] uppercase text-teal/90 font-mono">
              Smart Automated Intelligence
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
